import { styled, SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';


const List = styled('ul')({
  paddingLeft: '14px',
  '& li::marker': {
    color: 'orange',
  },
});

const imagePreview: SxProps = {
  backgroundImage: 'url("/testimonial/package-overview.jpg")',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'top center',
  minHeight: 800,
};

export const PackageOverview = () => {
  return (
    <Box position="relative" height="100%" >
      <Typography position="absolute" top={48} width="100%" px={2} variant="h1" fontWeight="bold" textAlign="center">
        The LGCY Package - Introductory Price{' '}
        <Typography component="span" fontWeight="bold" fontSize="inherit" color="error">
          $49.95
        </Typography>
      </Typography>
      <Box sx={imagePreview} />
      <Box position="absolute" width="100%" bottom={0} bgcolor="#efebe5" py={4} px={2} display="flex" justifyContent="center">
        <div>
          <Typography variant="h3" fontWeight="bold">
            LGCY Package Includes:
          </Typography>
          <List>
            <li>2 Interactive LGCY Keepsakes (size of a credit card)</li>
            <li>Personalized and sharable timeline</li>
            <li>Use of "Fluffy" our AI assistant to help tell their stories</li>
          </List>
        </div>
      </Box>
    </Box>
  );
};
